import {NpmModuleApiController} from './ApiController';
import {BaseSaveController} from '../core/SceneSaveController';
import {StoreController} from '../store/controllers/StoreController';

export class NpmModuleStatusPingController extends BaseSaveController {
	private _pingActive: boolean = false;
	private _pingsCount = 0;
	start() {
		this._pingActive = true;
		this._pingStatus();
	}
	private async _pingStatus() {
		if (!this._pingActive) {
			return;
		}
		const status = await NpmModuleApiController.getStatus({pingCount: this._pingsCount});
		this._pingsCount++;
		if (!this._pingActive) {
			return;
		}
		StoreController.editor.status.setLoading(status);
		setTimeout(() => {
			this._pingStatus();
		}, 1000);
	}
	end() {
		this._pingActive = false;
		this._pingsCount = 0;
	}
}
